import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/SKS_Logo_Negativ_RGB.png'


const _withScopeId = n => (_pushScopeId("data-v-68bfd66c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-footer" }
const _hoisted_2 = { class: "site-footer__primary" }
const _hoisted_3 = { class: "page-container" }
const _hoisted_4 = { class: "site-footer__primary-content" }
const _hoisted_5 = { class: "site-footer__menu" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "site-footer__title mt-5" }, "OM MUSEERNES SAMLINGER", -1))
const _hoisted_7 = { class: "accordion-links" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "site-footer__title mt-6" }, "SLOTS- OG KULTURSTYRELSEN", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Hammerichsgade 14"),
  /*#__PURE__*/_createElementVNode("li", null, "1611 København V"),
  /*#__PURE__*/_createElementVNode("li", null, "sara@slks.dk")
], -1))
const _hoisted_10 = { class: "menu-container" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sub-label" }, "Cookiepolitik", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sub-label" }, "Privatlivspolitik", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sub-label" }, "Tilgængelighedserklæring", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "right-item right-item-widescreen-only" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "website-logo",
    class: "logo original-logo"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-text-top" }, "Museernes"),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-text-bottom" }, "Samlinger")
], -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("div", null, [
              _hoisted_6,
              _createElementVNode("ul", _hoisted_7, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/about-page#hvor_kommer_data_fra" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Hvor kommer data fra?")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/about-page#sogning_i_museernes_samlinger" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Søgning i museernes samlinger")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/about-page#brug_af_billeder_og_data" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Brug af billeder og data")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/about-page#sporgsmal_eller_feedback_til_indholdet" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Spørgsmål eller feedback til indholdet")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/about-page#sporgsmal_eller_feedback_til_driften_af_museernes_samlinger" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Spørgsmål eller feedback til driften af museernes samlinger ")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _hoisted_8,
              _hoisted_9
            ]),
            _createElementVNode("ul", _hoisted_10, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  "data-testid-cookie-url": "",
                  href: _ctx.$t('navigation.cookie-url'),
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Cookiepolitik"
                }, _hoisted_13, 8, _hoisted_11)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  "data-testid-visit-url": "",
                  href: _ctx.$t('navigation.visit-url'),
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Privatlivspolitik"
                }, _hoisted_16, 8, _hoisted_14)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  "data-testid-terms-url": "",
                  href: _ctx.$t('navigation.terms-url'),
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Tilgængelighedserklæring"
                }, _hoisted_19, 8, _hoisted_17)
              ]),
              _createElementVNode("li", _hoisted_20, [
                _createElementVNode("a", {
                  href: "/",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearDisplayMode && _ctx.clearDisplayMode(...args)))
                }, _hoisted_22)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}